<template>
  <div class="construction-box">
    <div class="center-panel">
      <img-item
        v-for="item in topList"
        :key="item.id"
        :imgUrl="getImgUrl(item.topIcon)"
        :titleName="item.name"
        :num="item.number"
      ></img-item>
    </div>
    <div class="device-box">
      <div class="check-box">
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            v-for="item in pointData"
            :key="item.id"
            :label="item.name"
            :disabled="disabled"
            @change="checkboxChange(item.id, item.name)"
          ></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <dialog-view
      :show="showTipView"
      :x="positionX"
      :y="positionY"
      @showChange="showTipView = false"
    >
      <div class="tip-view">
        <div>{{ cameraInfo?.name ? `名称: ${cameraInfo.name}` : "" }}</div>
        <div>
          {{
            cameraInfo?.status
              ? `状态: ${cameraInfo.status === 0 ? "正常" : "异常"}`
              : ""
          }}
        </div>
        <div>
          {{ cameraInfo?.location ? `位置:  ${cameraInfo.location}` : "" }}
        </div>
        <div>{{ cameraInfo?.brand ? `品牌:  ${cameraInfo.brand}` : "" }}</div>
        <div>{{ cameraInfo?.volume ? `容量:  ${cameraInfo.volume}` : "" }}</div>
        <div>{{ cameraInfo?.weight ? `重量:  ${cameraInfo.weight}` : "" }}</div>
        <div>
          {{ cameraInfo?.manager ? `管理员:  ${cameraInfo.manager}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.phone ? `联系电话:  ${cameraInfo.phone}` : "" }}
        </div>
        <div>{{ cameraInfo?.spec ? `规格:  ${cameraInfo.spec}` : "" }}</div>
        <div>
          {{ cameraInfo?.parameter ? `参数:  ${cameraInfo.parameter}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.workTime ? `工作时间:  ${cameraInfo.workTime}` : "" }}
        </div>
        <div>
          {{
            cameraInfo?.businessTime
              ? `营业时间:  ${cameraInfo.businessTime}`
              : ""
          }}
        </div>
        <div>
          {{ cameraInfo?.openTime ? `开放时间:  ${cameraInfo.openTime}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.dutyNum ? `值班人数:  ${cameraInfo.dutyNum}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.pitNum ? `蹲位数:  ${cameraInfo.pitNum}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.spaceNum ? `车位数:  ${cameraInfo.spaceNum}` : "" }}
        </div>
        <div>
          {{ cameraInfo?.elotNum ? `剩余车位数:  ${cameraInfo.elotNum}` : "" }}
        </div>
        <div>
          {{
            cameraInfo?.chargeType ? `收费方式:  ${cameraInfo.chargeType}` : ""
          }}
        </div>
        <div>{{ cameraInfo?.remark ? `简介: ${cameraInfo.remark}` : "" }}</div>
        <img v-if="cameraInfo.image" :src="getImgUrl(cameraInfo.image)" />
      </div>
    </dialog-view>
  </div>
</template>

<script>
import ImgItem from '@/components/yt-component/ImgItem.vue'
// import coordtransform from 'coordtransform'
import DialogView from '@/components/yt-component/DialogView'
import { topData, allDevice, updateDevice } from '@/api/construction'
import PubSub from 'pubsub-js'
export default {
  components: {
    ImgItem,
    DialogView
  },
  data () {
    return {
      topList: [],
      pointData: [],
      allDevice: [],
      cameraInfo: {},
      // 地图点击事件
      markerId: null,
      positionObj: null,
      positionX: 0,
      positionY: 0,
      showTipView: false,
      checkList: [],
      disabled: false
    }
  },
  created () {
    setTimeout(() => {
      this.cameraPosition(
        -99087.75,
        -1921.799072265625,
        47684.9921875,
        34.98421096801758,
        -86.65238189697266,
        -124.96226501464844
      )
    }, 0)
    this.updateParking()
    this.getTopData()
    this.getAllDevice()
    // this.getPonitData()
  },
  mounted () {},
  beforeDestroy () {
    const inspur = this.$store.state.inspurMap
    const markerInstance = new inspur.Marker()
    markerInstance.clear()
  },
  methods: {
    getAllDevice () {
      allDevice().then((res) => {
        if (res.code === 200) {
          this.allDevice = res.rows
          PubSub.subscribe('addTipView', (msg, obj) => {
            console.log('接受到了订阅')
            // console.log(obj)
            // console.log('所有点' + this.allDevice)
            this.allDevice.forEach((item) => {
              // console.log('遍历点' + item)
              if (parseInt(item.id) === parseInt(obj.id)) {
                this.cameraInfo = item
                console.log('找到点')
                // console.log(item)
              }
            })
            this.positionX = obj.x + 'px'
            this.positionY = obj.y + 'px'
            this.showTipView = true
          })
          this.getPonitData()
        }
      })
    },
    updateParking () {
      updateDevice().then((res) => {
        if (res.code === 200) {
          console.log('调用了更新停车剩余车位的接口')
        }
      })
    },
    getTopData () {
      topData({ topFlag: 1 }).then((res) => {
        if (res.code === 200) {
          this.topList = res.rows
        }
      })
    },
    getPonitData () {
      topData({ pointFlag: 1 }).then((res) => {
        if (res.code === 200) {
          this.pointData = res.rows
        }
      })
    },
    getImgUrl (str) {
      if (str) {
        return process.env.VUE_APP_BASE_URL + str
      }
      // else {
      //   return require('../assets/temp.jpeg')
      // }
    },
    checkboxChange (id, name) {
      this.disabled = true
      console.log(id, name)
      const flag = this.checkList.indexOf(name) === -1
      console.log(this.checkList)
      console.log('是否不包含：' + flag)
      const arr = this.allDevice.filter((item) => {
        return item.categoryId === id
      })
      console.log(arr)
      const inspur = this.$store.state.inspurMap
      const markerInstance = new inspur.Marker()
      if (flag) {
        // 清除
        // 先清空
        // await markerInstance.clear()
        this.deleteMarker(markerInstance, arr)
      } else {
        // 添加
        this.addMarker(markerInstance, arr)
      }
    },
    addMarker (markerInstance, points) {
      for (const pointInfo of points) {
        if (!pointInfo.longitude || !pointInfo.latitude) {
          return
        }
        markerInstance.add({
          scale: 0.3,
          id: pointInfo.id,
          // name: item.name,
          isGraphic: true,
          visible: true,
          type: pointInfo.type,
          position: {
            x: pointInfo.longitude,
            y: pointInfo.latitude,
            z: 20
          }
        })
      }
      setTimeout(() => {
        this.disabled = false
      }, 1000)
    },
    deleteMarker (markerInstance, points) {
      for (const pointInfo of points) {
        if (!pointInfo.longitude || !pointInfo.latitude) {
          return
        }
        // 标注
        markerInstance.remove(pointInfo.id)
      }
      setTimeout(() => {
        this.disabled = false
      }, 1000)
    },
    // 调整相机角度
    cameraPosition (x, y, z, roll, pitch, yaw) {
      const inspur = this.$store.state.inspurMap
      const position = {
        x,
        y,
        z,
        rotation: {
          roll,
          pitch,
          yaw
        }
      }
      const camera = new inspur.Camera()
      camera.flyTo(position)
    }
  }
}
</script>

<style lang="scss" scoped>
.construction-box {
  width: 100%;
  height: 100%;
  position: relative;
  .center-panel {
    pointer-events: auto;
    position: absolute;
    top: 100px;
    left: 10%;
    width: 80%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .device-box {
    pointer-events: auto;
    position: absolute;
    bottom: 56px;
    right: 30px;
    height: 500px;
    width: 327px;
    background: url("../assets/device_bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 40px;
    .check-box {
      width: 100%;
      height: 100%;
    }
  }
}
.tip-view {
  max-width: 500px;
  color: #fff;
  background-color: rgba(82, 89, 103, 0.6);
  padding: 16px;
  border: 1px solid #00fff6;
  border-radius: 4px;
  div {
    padding-bottom: 8px 0;
  }
  img {
    // height: 120px;
    width: 100%;
  }
}
</style>
